import {Button, Icon, Loading} from '@startlibs/components';
import {Errors, FormValue, TextInput, WithForm} from '@startlibs/form';
import _ from 'lodash/fp'
import React, { useEffect, useRef, useState } from 'react'
import { Card, PageContainer, RequestStatusIcon } from '../../components/PageLayout'
import {CaseRequestCard} from '../CaseRequestCard';
import {ConfirmDialog, useConfirmDialog} from '../../hooks/useConfirmDialog';
import {ContactCard} from '../../components/ContactCard';
import {ContactSelectBoxes} from './RecordsStep';
import {ContactSelectInput} from '../../components/ContactSelectInput';
import {Header} from '../../components/Header';
import {getJwt} from '../../hooks/useJwt';
import {jwtPostFetcher} from '../../utils/authFetch';
import {getColor, media, will} from '@startlibs/utils'
import {CASE_DRAFT, isPendingAskingMore} from '../../enums/CaseState'
import {REQUESTED} from '../../enums/ContactRelationKind'
// import {isPendingAskingMore} from '../../patient/utils/patientUtils'
import styled from 'styled-components';
import { ThreadCard } from './ThreadCard';
import { buildValidation, required } from '../../utils/validation';
import { setNotification } from '../../components/Notifications';
import { lazyProviderInfo } from '../../components/WithProvider';
import { InfoBox } from '../../components/InfoBox';









const InfoBadge = styled.span`
    border-radius: 20px;    
    font-size: 11px;
    font-weight: 500;
    padding: 0 0.75rem;
    margin: 0px 8px;
    ${props => props.type === 'Admin' && `
      background: #e2e2e2;
      color: #555555;
    `}
    ${props => props.type === 'Patient' && `
      background: #cce4d4;
      color: #009900;
    `}
    ${props => props.type === 'request' && `
      margin: 0px 4px;
      background: transparent; 
      color: #555555;
      border: 1px solid #555555;
    `}

`

const PaddedContainer = styled.div`
  padding-right: 13rem;
  position: relative;
  ${media.max(520)`
    padding-right: 13rem;
  `}
`


const ReturnButton = styled(Button) `
  box-shadow: none;
  color: ${getColor('gray60')};
  font-weight: bold;
  margin-bottom: 1.5rem;
  ${Icon} {
    font-size: 20px;
  }
`

export const WaitingPatientUpdates = ({caseRequest,setCaseRequest, thread, setShouldReloadData, isLoadingCollab}) => {
  // const paymentIsPending = isOfflinePaymentPending(caseRequest)
  const isAccepted = _.get('acceptanceInfo.accepted',caseRequest) && _.get('medicalRecordsReleaseLicense',caseRequest)

  const providerInfo = lazyProviderInfo.read()
  const caseContactsNotifications = providerInfo?.caseContactsNotifications

  useConfirmDialog(<ConfirmDialog
    title="It is longer possible to revoke acceptance"
    closeButton={<Button onClick={() => window.location.reload()}>Close</Button>}
  >
    <p>This case has already been accepted. Click below to refresh the page and see the case.</p>

  </ConfirmDialog>);

  const revokeConfirm = useConfirmDialog(
    <ConfirmDialog
      title="Revoke request"
      confirm={<Button alert>Revoke</Button>}
      action={(v) => jwtPostFetcher(getJwt())("/api/admin/revokeRequestMedicalRecords?requestId="+caseRequest.requestId,v)}
      onSuccess={will(setCaseRequest,_.flow(isPendingAskingMore(caseRequest) ? _.identity : _.set("state", CASE_DRAFT),_.set('caseFlags.requestFlags',{})))}
    >
      <p>The contacted party will no longer have editing permissions.</p>
      <CaseRequestCard caseRequest={caseRequest} viewOnly />
      <p>Do you wish to proceed?</p>
    </ConfirmDialog>
  )

  const reminderConfirm = useConfirmDialog(
    <ConfirmDialog
      title="Send reminder"
      confirm={<Button highlight icon="mail" disabled={!caseContactsNotifications}>Send</Button>}
      values={caseRequest.caseFlags}
      action={(v) => jwtPostFetcher(getJwt())("/api/admin/sendRequestMedicalRecordsReminder?requestId="+caseRequest.requestId,v)}
      notify="Reminder sent successfully."
    >
      <p>Remind the listed party to complete requested actions on the following case:</p>
      <CaseRequestCard caseRequest={caseRequest} viewOnly />
      {caseContactsNotifications ? <>
          <p>The reminder will be sent to:</p>
          <ContactSelectBoxes path="contactRelationType">
            <ContactSelectInput
              raw
              value={true}
              fieldValue={true}
              caseRequest={caseRequest}
              relationKind={REQUESTED}
              viewOnly
            >
            </ContactSelectInput>
          </ContactSelectBoxes>
          <TextInput
            textarea
            autoResize
            label="Message"
            path="message"
            descText="This will be included in the reminder email."
            placeholder="Insert custom message here."
          />
        </>
      : <InfoBox lightYellow>
          Communication is disabled              
        </InfoBox>
      }
     
    </ConfirmDialog>
  )

  const VIEW = 'VIEW';
  const NEW = 'NEW';
  const REPLY = 'REPLY';
  const [isSending, setIsSending] = useState(false)
  const [mode, setMode] = useState(VIEW)
  const [replyId, setReplyId] = useState(null)
  const msgFormRef = useRef()
  const msgFieldRef = useRef()
  const preValidationMsg = buildValidation({
   'message': [
      (v) => !v && required(),
      (v) => v?.length > 3000 && 'Message: Maximum character limit of 3000 reached.'
    ]
  })
  const replyAction = (id) => {
    setReplyId(id)
    setMode(REPLY)
  }

  useEffect(() => {
    if (replyId) {
      msgFieldRef.current.focus()
    }
  }, [replyId])

  return <><PageContainer css="padding-bottom: 1rem; min-height: 600px;">
      <Header title="Message case contact">
      </Header>
      <Card>
        {mode === VIEW && <PaddedContainer>
          <RequestStatusIcon icon="clock"/>
          <h3>
            Waiting for updates from the case contact
          </h3>
          <ContactCard
            caseRequest={caseRequest}
            relationKind={REQUESTED}
          />          
          <p css="margin-bottom:1.5rem;">If the contact takes too long to provide the updates, you can send them a new message or revoke this update request, allowing you to edit the related steps again.</p>
        </PaddedContainer>}
        {isLoadingCollab && <Loading css="margin: 6rem auto" />}
        {!isLoadingCollab && caseRequest.requestCollaborationId && mode === VIEW &&
          <ThreadCard 
            thread={thread} 
            caseRequest={caseRequest} 
            setShouldReloadData={setShouldReloadData}
            replyAction={replyAction}
          />
        }
        
        {(mode === REPLY) && <>
          <ReturnButton 
            noShadow rounded color="gray240" icon="return"
            onClick={() => {
            setMode(VIEW)
            setReplyId(null)
          }}>Go back</ReturnButton>
          {replyId && replyId > 0 && replyId != null && <ThreadCard thread={thread} caseRequest={caseRequest} isReplying/>}
          <WithForm
            preValidation={preValidationMsg}
            action={(values) => {
              setIsSending(true)
              return jwtPostFetcher(getJwt())(`/api/collaborations/${replyId}/messages?requestId=${caseRequest.requestId}`, {...values} ,{method: 'POST'})
            }}
            onSuccess={(_values) => {
              if(setShouldReloadData){
                setShouldReloadData(true)
              }
              setNotification("Message sent")
              setIsSending(false)
            }}
            ref={msgFormRef}
            onFailure={() => {
              setIsSending(false)
            }}
          >
            {form => <>
              <TextInput
                textarea
                ref={msgFieldRef}
                autoResize
                placeholder="Type your message here..."
                path="message"
                mandatory={true}
                label={mode === NEW ? 'Write your message' : 'Reply message'}
                onChange={(e) => {
                  if(e.length > 3000){
                    form.addErrors({message: 'Message: Maximum character limit of 3000 reached.'})
                  }else{
                    form.clearErrors('message')
                  }
                }}
                bellowDescText={
                  <FormValue path="message">{message => {
                    if(message){
                      return <span style={{ 
                        display: 'block',
                        width: '100%',
                        textAlign: 'right'
                      }}>{message?.length+"/3000"}</span>
                    }
                  }}</FormValue>
                }
              />
              <Errors css="margin-bottom: 1rem;"/>
              <div css="text-align: right">
                <Button
                  highlight
                  type="submit"
                  icon="mail"
                  isLoading={isSending}
                >
                  Send message
                </Button>
              </div>
            </>}
          </WithForm>
        </>}
        {/* WITHOUT COLLAB ID - PREVIOUS REQUEST EXISTING - WITHOUT THREAD */}
        {!isLoadingCollab && !caseRequest.requestCollaborationId && <ThreadCard caseRequest={caseRequest}/>}
        <div css="margin-top:2rem; text-align: end;">
          {!caseRequest.requestCollaborationId && <Button highlight icon="mail" onClick={reminderConfirm}>Send a reminder</Button>}
          {mode === VIEW  && <Button onClick={revokeConfirm} hover="alert">Revoke request</Button>}
        </div>
      </Card>
  </PageContainer>
  {/* <PurviewFooter/> */}
</>
}
